@if (notification) {
<div
  [@slideFromRight]
  (@slideFromRight.done)="onAnimationDone($event)"
  atxClickOutside
  (clickOutside)="close()"
  class="basket-notification d-flex flex-column position-relative"
  [ngClass]="additionalCssClasses"
>
  <div class="d-flex p-2">
    @if (!options.hideProductImage) {
    <div class="image-wrapper flex-shrink-0 mr-2">
      <atx-image
        [imageUrl]="notification.imageUrl"
        [maxWidth]="imageMaxSizes.THUMBNAIL"
      ></atx-image>
    </div>
    }
    <div
      class="d-flex flex-column justify-content-between py-1 overflow-hidden flex-grow-1"
    >
      <div>
        <p
          class="product-title mb-1 pr-3"
          [ngClass]="{ 'text-truncate': options.hideAddedToBasketMessage }"
        >
          {{ notification.productTitle }}
          @if (!options.hideAddedToBasketMessage) {
          <span
            i18n="
              BasketNotification|Basket notification has been added
              message@@basketNotificationAddedMessage"
            >has been added to the basket</span
          >
          }
        </p>
        @if (!options.hideProductId) {
        <p class="product-info text-dark">
          {{ notification.productId }}
        </p>
        }
      </div>
      @if (notification.totalQuantity > 0) { @if (!options.hideNumbers) {
      <div class="d-flex justify-content-between product-info text-dark">
        <span
          i18n="
            BasketNotification|Basket notification items
            quantity@@basketNotificationQuantityItemsText"
          data-e2e="basket-notification-items"
          >{{ notification.totalQuantity }} items</span
        >
        <span data-e2e="basket-notification-price">
          {{
            trimWhitespace(
              notification.totalRequestedPrice
                | currency
                  : notification?.currency
                  : '&nbsp;' + (notification?.currency || '') + '&nbsp;'
                  : '1.2-2'
            )
          }}</span
        >
      </div>
      } } @else {
      <div class="d-flex">
        <span
          i18n="
            BasketNotification|Basket notification when item is
            removed@@basketNotificationItemRemoved"
          class="text-danger"
          data-e2e="basket-notification-product-remove"
          >Product was removed from the basket</span
        >
      </div>
      }
    </div>
  </div>

  @for (error of basketValidationErrors; track error.message) {
  <atx-alert class="my-1 mx-2" [severity]="error.severity">
    <span [innerHTML]="error.message"></span>
  </atx-alert>
  } @if (showNavigateToBasketButton) {
  <button
    (click)="navigateToBasket()"
    class="view-basket btn"
    [ngClass]="additionalViewBasketButtonClasses"
  >
    {{ basketButtonText }}
  </button>
  } @if (!options.hideRecommendationPanel) {
  <epc-recommendation-panel
    [location]="RecommendationsPanels.AddedToBasketNotification"
  ></epc-recommendation-panel>
  } @if (!options.hideCloseButton) {
  <button
    data-e2e="basket-notification-btn-close"
    (click)="close()"
    class="btn position-absolute close-icon p-2"
  >
    <fa-icon size="sm" [icon]="['fas', 'xmark']"></fa-icon>
  </button>
  }
</div>
}
